import api from './api';
import { handleError } from './handle-error';
// import { toastSuccess } from './toast';


export const scaleList = async (scale_id) => {
  const result = new Promise((resolve) => {
    api
      .get(`scales/${scale_id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch(async (error) => {
        const response = await handleError(error);

        resolve(response);
      });
  });
  return result;
};

export const lastScale = async () => {
  const result = new Promise((resolve) => {
    api
      .get(`scales/last`)
      .then((response) => {
        resolve(response.data);
      })
      .catch(async (error) => {
        const response = await handleError(error);

        resolve(response);
      });
  });
  return result;
};

